// @flow

require('./js/primitive');
require('./js/combinator');
require('./js/native');
require('./js/array');
require('./js/string');
require('./js/kladr');
require('./js/moment');
require('./js/file');
require('./js/misc');
require('./js/address');
require('./js/identity-document');

const vb = require('./js/definition');

export type {
	Validator,
} from './types';

module.exports = vb;
